import { userCan } from "@/services/helpers";

export const PRICING_TOOL_PERMISSION = "use pricing tool";

/** Whether the tool is offered to this user at all: rolled out to them and allowed by their role. Locked until the company has it. */
export function offersPricingTool(store) {
  return store.getters["auth/hasFeatureFlag"]("pricing-tool") && userCan(PRICING_TOOL_PERMISSION, store.state.auth.user);
}

/** Whether the user can open the tool now. */
export function canUsePricingTool(store) {
  const config = store.getters["companies/currentCompany"]?.config ?? store.state.auth.user?.current_company?.config;
  return offersPricingTool(store) && Boolean(config?.can_use_pricing_tool);
}
